
import {defineComponent} from 'vue';
import {toastMixin} from './toast-mixin';

export default defineComponent({
  name: 'oxd-toast-close-button',

  mixins: [toastMixin],

  computed: {
    classes(): object {
      return {
        'oxd-toast-close': true,
        [`oxd-toast-close--${this.type}`]: true,
      };
    },
  },
});
